module.exports = __webpack_public_path__ + "img/核心技术--人脸关键点.f6665d62.png";